import PropTypes from 'prop-types';
import cn from 'classnames';

import model from './ObjectModel.module.scss';

export const Property = ({ propKey, propVal, propClass }) => {
  return (
    <div className={cn(propClass, model.model__control)}>
      <br />
      {propKey}: {String(propVal)}
    </div>
  );
};
Property.propTypes = {
  propKey: PropTypes.string,
  propVal: PropTypes.any,
  propClass: PropTypes.string,
};

export default Property;
